module.exports = __webpack_public_path__ + "static/media/Room10.7cdd45f1.PNG";